module.exports = __webpack_public_path__ + "assets/img/znjkbpg.5d0090d9.png";